import { useEffect, useState } from 'react';

import { db } from '@/renderer/lib/powersync/database';

/**
 * Returns the current number of CRUD operations waiting to be uploaded to
 * Supabase. Refreshes on every PowerSync status event and polls every 2s
 * so the count stays accurate between events (e.g. when writes are queued
 * faster than status events fire).
 */
export function usePendingCrudCount(): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let disposed = false;

    const refresh = async () => {
      try {
        const stats = await db.getUploadQueueStats();
        if (!disposed) setCount(stats.count);
      } catch {
        // db not ready yet — keep previous count
      }
    };

    refresh();

    const unsub = db.registerListener({ statusChanged: refresh });
    const timer = window.setInterval(refresh, 2000);

    return () => {
      disposed = true;
      unsub();
      window.clearInterval(timer);
    };
  }, []);

  return count;
}
